import { type PlayerProfileResponse } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { Stars } from '@on3/ui-lib/components/Player/Stars';
import { webUrl } from '@on3/ui-lib/utils/api';
import clsx from 'clsx';

import styles from './PlayerTile.module.scss';

interface PlayerTileProps {
  player?: Partial<PlayerProfileResponse>;
  className?: string;
  targetType?: '_blank' | '_self' | '_parent';
}

export const PlayerTile = ({
  player,
  className,
  targetType,
}: PlayerTileProps) => {
  const {
    highSchoolName,
    name,
    slug,
    defaultAsset,
    classYear,
    positionAbbreviation,
    height,
    ranking,
    hometownName,
    weight,
  } = player || {};

  return (
    <div className={clsx(styles.block, className)}>
      <figure>
        <Avatar
          domain={defaultAsset?.domain}
          height={50}
          quality={95}
          source={defaultAsset?.source}
          width={50}
        />
      </figure>
      <div className={styles.details}>
        <div className={styles.player}>
          <Link
            className={styles.name}
            href={slug && webUrl + `/rivals/${slug}/`}
            target={targetType}
          >
            {name}
          </Link>
        </div>
        <p className={styles.measurements}>
          {!!classYear && <span>{`${classYear} H.S.`}</span>}
          {!!positionAbbreviation && <span>{positionAbbreviation}</span>}
          {!!height && <span>{height}</span>}
          {!!weight && <span>{weight}</span>}
        </p>
        <p className={styles.hometown}>
          <span>{highSchoolName}</span>
          {player?.hometownName && <span>({hometownName})</span>}
        </p>
        <div className={styles.stars}>
          <Stars stars={ranking?.stars} />
          {!!ranking?.rating && (
            <span className={styles.rating}>{ranking?.rating?.toFixed(2)}</span>
          )}
        </div>
      </div>
    </div>
  );
};
